let tableWrapperInit = (template) => {
  let editorWrapper = document.querySelector('.template')
  if (editorWrapper) {
    let tables = document.querySelectorAll('table')
    tables = Array.from(tables)
    const zero = 0
    if (zero < tables.length) {
      tables.forEach(el => {
        let wrapper = document.createElement('div')
        el.parentNode.insertBefore(wrapper, el)
        wrapper.appendChild(el)
        wrapper.classList.add('table-wrapper')
      })
    }
  }
}
export default tableWrapperInit



// WEBPACK FOOTER //
// ./src/js/scripts/tableWrapper.js